import { log, logTable } from './utils'

export const config = {
  backend: process.env.REACT_APP_BACKEND,
  ga: process.env.REACT_APP_GA_KEY,
}

log('Config:')
logTable(config)
